export { parentGuardianModuleName as moduleName } from '@shared';

export const adultPositionsForParticipant = [
  'Unit College Scouter Reserve',
  'Assistant Scoutmaster',
  'Unit Scouter Reserve',
];
